import i18next from 'i18next';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../components/helpers/index';

import './challenge-title.css';

interface BreadCrumbProps {
  block: string;
  superBlock: string;
}

function BreadCrumb({ block, superBlock }: BreadCrumbProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      <style jsx>{`
        .breadcrumbs-demo {
          height: unset !important;
          padding: 0 !important;
        }
        .w4j-breadcrumbs-wrapper {
          margin-top: 32px;
          margin-bottom: 12px;
          padding: 0px 20px;
          width: 100%;
        }
        .w4j-breadcrumbs-wrapper nav {
          width: 100% !important;
          background-color: #F3F3F3;
          padding: 10px 20px;
          border-radius: 10px;
          }
          .w4j-breadcrumbs-wrapper nav ol {
            gap: 8px;}
          .w4j-breadcrumbs-wrapper nav li {
            margin: 0 !important;
            padding: 0 !important;}
          .w4j-breadcrumbs-wrapper .breadcrumb-left {
            text-decoration: underline !important;}
          .w4j-breadcrumbs-wrapper .breadcrumb-right {
            font-weight: 500 !important;}
        .w4j-breadcrumbs-wrapper nav ol {
          width: fit-content !important;}
        .w4j-breadcrumbs-wrapper nav * {
          font-size: 16px !important;
          color: black !important;}
        `}
    </style>
    <div class="w4j-breadcrumbs-wrapper">
      <nav 
        className='challenge-title-breadcrumbs'
        aria-label={t('aria.breadcrumb-nav')}
      >
        <ol data-playwright-test-label='breadcrumb-desktop'>
          <li className='breadcrumb-left'>
            <Link
              state={{ breadcrumbBlockClick: block }}
              to={`/learn/${superBlock}`}
            >
              <span>{i18next.t(`intro:${superBlock}.title`)}</span>
            </Link>
          </li>
          <span>{'>'}</span>
          <li className='breadcrumb-right'>
            <Link
              state={{ breadcrumbBlockClick: block }}
              to={`/learn/${superBlock}/#${block}`}
            >
              {i18next.t(`intro:${superBlock}.blocks.${block}.title`)}
            </Link>
          </li>
        </ol>
      </nav>
    </div>
    </>
  );
}

BreadCrumb.displayName = 'BreadCrumb';

export default BreadCrumb;
